import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent
} from '@/components/ui/card';
import { useTenants } from '@/data/tenant';
import Loader from '@/components/common/Loader';

import TenantList from './list/TenantList';
import AddTenantDialog from './list/AddTenantDialog';

const List = () => {
  const tenants = useTenants();

  let content = <Loader />;
  if (!tenants.isLoading) {
    content = <TenantList />;
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex justify-between items-center mb-4">
          Tenants <AddTenantDialog />
        </CardTitle>
        <CardDescription>
          ProFound Tenants. Tenants are paying customers that can manager their
          own fleet of coaches who sign up to coach at a tenants location.
        </CardDescription>
      </CardHeader>
      <CardContent>{content}</CardContent>
    </Card>
  );
};

export default List;
